document.addEventListener('DOMContentLoaded', function () {
  var modules = document.querySelectorAll('.swm26-newsletter');

  modules.forEach(function (module) {
    var fields = module.querySelectorAll('.swm26-newsletter__fieldwrap');

    fields.forEach(function (field) {
      var input = field.querySelector('.swm26-newsletter__input');
      if (!input) return;

      var syncState = function () {
        field.classList.toggle('is-filled', input.value.trim() !== '');
      };

      input.addEventListener('focus', function () {
        field.classList.add('is-focused');
      });

      input.addEventListener('blur', function () {
        field.classList.remove('is-focused');
        syncState();
      });

      input.addEventListener('input', syncState);

      syncState();
    });
  });
});